// extracted by mini-css-extract-plugin
module.exports = {"title":"Liste_title__2Op7z","list":"Liste_list__Ba3DE","item":"Liste_item__1Gwai","link":"Liste_link__3dClB"};